import { Typography } from 'antd';
import React from 'react';

interface RFLegendProps {
  legend: { l: string; r: number; g: number; b: number }[];
}
const RFLegend: React.FC<RFLegendProps> = ({ legend }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', padding: '8px', borderRadius: '8px' }}>
      <Typography.Text style={{ fontSize: '0.8rem' }}>dBm</Typography.Text>
      {legend.map((item) => (
        <div key={item.l} className="row-wise gap-2 vertical-center">
          <div style={{ backgroundColor: `rgb(${item.r}, ${item.g}, ${item.b})`, height: '1.3rem', width: '1rem' }}></div>
          <Typography.Text style={{ fontSize: '0.8rem' }}>{item.l.split('dBm')[0]}</Typography.Text>
        </div>
      ))}
    </div>
  );
};

export default RFLegend;
